import { SiteData } from "./Data/SiteData";


type imageValdationObject = {
    image: string,
    index:number,
    mapped:boolean,
    attemps:number
}

export default async function ValidateAllImages(siteData:SiteData){

    let images:imageValdationObject[] = [];
    const resultData = {
        total:0,
        finished:0,
    }
    const updateResults = ()=>{
        resultData.finished++;
    
        if(resultData.finished>=resultData.total){
    
            siteData.designer?.forceUpdate();
        }
    
        }

    for(let i = 0;i<siteData.imageUrls.length;i++){
        images.push({image:siteData.imageUrls[i],index:i,mapped:false,attemps:0});
        resultData.total++;
    }
    
    for(let i = 0;i<siteData.siteStyling.imageMapping.length;i++){
        images.push({image:siteData.siteStyling.imageMapping[i],index:i,mapped:true,attemps:0});
        resultData.total++;
    }




//check if the cdns need to be swapped....
const cdnA = "https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/";
const cdnB =  "https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/";

const validateImage = async (img:imageValdationObject) => {

    if(!img.image.includes(cdnA)&&!img.image.includes(cdnB)){
        updateResults();
        return;
    }

    const test = new Image();
    test.src = img.image;

    test.onerror = function() {

        img.attemps++;

        if(img.attemps<3){
            if(img.image.includes(cdnA))
                img.image = img.image.replace(cdnA,cdnB);
            else if(img.image.includes(cdnB))
                img.image = img.image.replace(cdnB,cdnA);
            else {
                updateResults();
       
                return;
                
            }

            validateImage(img);
        }


    }

    test.onload = function() {
    
        if(img.attemps<=0){
            updateResults();
            return; // first success just ignore
        }

        console.log("Updated Image: ",img.image);
        siteData.isStyleSaveDirty = true;
        if(img.mapped){
        
            siteData.siteStyling.imageMapping[img.index] = img.image;
            siteData.userContext.imageMapping[img.index] = img.image;

            updateResults();
        }
        else{
            siteData.imageUrls[img.index] = img.image;
            updateResults();
        }

    }

}


for(let i = 0;i<images.length;i++){
    validateImage(images[i]);
}



}